import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getImageFilepath, getViewportDimensions } from '../../../../models/Utils';

import { ADALandmarks, ADAARIARoles } from '../../../../models/ADA';

import './AllThemesGrid.scss';

const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const AllThemesGrid = ({ themes, currentTheme, exploreButtonLabel, darkMode, onExploreClick }) => {
  const [isMobile, setIsMobile] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);

  const getThemeIndex = (theme) => {
    return themes.map((t) => t.Key).indexOf(theme.Key);
  };

  const getThemeList = () => {
    const size = getViewportDimensions();
    let retValue = [];
    let columns = [];
    const filteredThemes = themes.filter((theme) => !currentTheme || theme.Key !== currentTheme.Key);
    filteredThemes.forEach((theme, i) => {
      columns.push(
        <div className="cpvi-grid-col w6" key={i}>
          <div className="ccw-atg-theme-container">
            <div className="ccw-atg-thumbnail-wrapper">
              <div className="ccw-atg-thumbnail-inner">
                <img
                  className="ccw-atg-thumbnail"
                  src={
                    mediaPath +
                    getImageFilepath(
                      theme.DesktopImage.Image,
                      size.width * 2
                    )
                  }
                  width={'100%'}
                  alt={theme.DesktopImage.AltText}
                  aria-hidden={true}
                />
              </div>
            </div>
            <div className="ccw-atg-description" role={ADAARIARoles.Heading}>{theme.Title}</div>
            <div><button className="button-holder" tabIndex={!menuOpened ? 0 : -1} role={ADAARIARoles.Presentation} onClick={() => onExploreClick(getThemeIndex(theme))}>{exploreButtonLabel}</button><span className="ccw-atg-link-addition">: {theme.Title}</span></div>
          </div>
        </div>
      );
      if (columns.length === 2 || i === filteredThemes.length - 1) {
        retValue.push(
          <div className="cpvi-grid-row" key={i*2}>
            {[...columns]}
          </div>
        );
        columns = [];
      }
    });
    return retValue;
  };

  return (
    <div className={`ccw-all-themes-grid ${darkMode ? 'dark-mode' : ''}`}>
      <div className="cpvi-grid-container">
        {getThemeList()}
      </div>
    </div>
  );
};

export default AllThemesGrid;